// Pure helpers for the OAST monitor: one feed of callbacks across all addresses, and a plain-words explanation.
import { scanLabel } from './webScanLogic';

export const isManual = (s) => !s.scan || s.metadata?.source === 'manual';
export const causeOf = (s) => (isManual(s) ? 'Added by hand' : [scanLabel(s.scan_type), s.label].filter(Boolean).join(' · '));

// events: { [sessionId]: [event] } -> callbacks newest first, each tagged with the address it hit.
export function buildFeed(sessions, events) {
  const byId = Object.fromEntries(sessions.map((s) => [String(s.id), s]));
  return Object.entries(events).flatMap(([id, list]) => (list || []).map((e) => ({
    ...e, sessionId: id, cause: byId[id] ? causeOf(byId[id]) : '', sessionLabel: byId[id]?.label || `Address ${id}`
  }))).sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
}

// "The server at X contacted your addresses N times ..." Empty string when nothing was received.
export function explain(feed) {
  if (!feed.length) return '';
  const ips = {};
  feed.forEach((e) => { const ip = e.source_ip || 'an unknown server'; ips[ip] = (ips[ip] || 0) + 1; });
  const [top, n] = Object.entries(ips).sort((a, b) => b[1] - a[1])[0];
  const others = Object.keys(ips).length - 1;
  const who = `${top === 'an unknown server' ? top : `The server at ${top}`} contacted your callback addresses ${n} time${n === 1 ? '' : 's'}${others > 0 ? `, and ${others} other server${others === 1 ? '' : 's'} did too` : ''}`;
  return `${who}. A scan put these addresses in its test input, so this usually means the target fetches addresses it is given, or runs injected code, even when the page shows no error. Treat it as a confirmed weakness and open the scan that caused it.`;
}

export const eventCount = (sessions) => sessions.reduce((n, s) => n + Number(s.callbacks_count || 0), 0);
